import React from 'react';
import { Search } from 'lucide-react';
import Header from '@/common/Header';
import Footer from '@/common/Footer';
import '../style/products/bridge.css'; // CSS file
import logo from '../img/quanto_light.png'; // Header logo
import backgroundImage from '../img/product-bridge/retailbridge.png'; // Background image

export default function QuantoBridge() {
  return (
    <>
      <Header />
      <section className="about-title-section">
        <h2><img alt="quantologo" src={logo} style={{ width: 280, marginLeft: 10, verticalAlign: "middle", marginBottom: 20 }} />Bridge</h2>
      </section>
      <div className="coming-soon-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <div className="search-box">
          <p className="search-text">Get ready for the next big Innovation… Coming soon!</p>
          {/* Vertical separator */}
          {/* <div className="vertical-line"></div>  */}
          <a href="/get-demo">
            <Search className="search-icon" />
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
}
